/* src/app/settings/pages/user-role-edit/user-role-edit.component.scss */
/*# sourceMappingURL=user-role-edit.component.css.map */
